module.exports = __webpack_public_path__ + "img/cancel-after-timeout.00c0180c.png";